<script setup lang="ts">
import { computed } from 'vue';
import type { TypingMessage } from '@/library/message/types';
import { MemberType } from '@/library/message/enum';
import { useChatMessageCustomisation } from '../composables/useChatMessageCustomisation';

import ChatMessageWrapper from './ChatMessageWrapper.vue';

const props = defineProps<{
  message: TypingMessage;
  /**
   * The previous message/notice in the stack.
   */
  previous?: unknown;
  /**
   * The next message/notice in the stack.
   */
  next?: unknown;
}>();

// Customisation
const customisation = useChatMessageCustomisation();

const dotStyle = computed(() => {
  const isAgent = props.message.memberType === MemberType.AGENT;
  const backgroundColor = isAgent
    ? customisation.chatbotBubbleTextColor.value
    : customisation.userBubbleTextColor.value;

  return backgroundColor ? { background: backgroundColor } : {};
});
</script>

<template>
  <ChatMessageWrapper class-body="p-2" v-bind="$props">
    <div class="loader w-10" data-testid="typing-indicator">
      <span v-for="i in 3" :key="i" :style="dotStyle"></span>
    </div>
  </ChatMessageWrapper>
</template>

<style>
.loader {
  text-align: center;
}
.loader span {
  display: inline-block;
  vertical-align: middle;
  width: 0.8rem;
  height: 0.8rem;
  /* background: black; */
  border-radius: 0.8rem;
  animation: loader 0.5s infinite alternate;
}
.loader span:nth-of-type(2) {
  animation-delay: 0.2s;
}
.loader span:nth-of-type(3) {
  animation-delay: 0.6s;
}
@keyframes loader {
  0% {
    opacity: 0.9;
    transform: scale(0.5);
  }
  100% {
    opacity: 0.1;
    transform: scale(1);
  }
}
</style>
